import React from 'react'
import Pagetitle from './../components/pagetitle/Pagetitle'
import Servicedetail from '../components/servicedetail/Servicedetail'
import softwaredevelopmentimg from './../Images/SoftwareDevelopment-4ff52a3311061b610b5cfb58d8ba0e09.png'
export default function Softwaredevelopment() {
  const servicetechnologies = ['JavaScript',
'HTML',
'Git',
'CSS',
'SQL']
  return (
    <div>
      <Pagetitle pagename="Software Development" parentpage="Home"/>
      <Servicedetail serviceimg={softwaredevelopmentimg} technologies={servicetechnologies} servicesabout="Making software programs are not an easy job, but our Software developers are very experienced and familiar with all modern tools" />
    </div>
  )
}
